import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable, of} from "rxjs";
import {TmsAction} from "../models/tms-action.interface";
import { environment } from "../../../environments/environment";
import { map, take } from "rxjs/operators";
import { ActionCodeColor } from "../models/action-code-color";
import { ActionCode } from "../models/action-code";

@Injectable({
  providedIn: "root"
})
export class TmsActionService {

  constructor(private httpClient: HttpClient) {
  }

  fetchAll(): Observable<TmsAction[]> {
    return this.httpClient.get(environment.tmsApiEndpointAddress + "planning/action-codes")
      .pipe(
        take(1),
        map((response: any) => {
          const dataList = response.data || [];

          // IF you change the code also change it inside the 2 pipes
          dataList.push({
            code: "COMPLETED"
          });

          return dataList;
        })
      );
  }
}
